import "core-js/modules/es.json.stringify.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "stream-debug-overlay__counts"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = {
  class: "stream-debug-overlay__head-actions"
};
const _hoisted_4 = {
  class: "stream-debug-overlay__body"
};
const _hoisted_5 = {
  class: "stream-debug-overlay__pane"
};
const _hoisted_6 = {
  class: "stream-debug-overlay__pane-head"
};
const _hoisted_7 = {
  class: "stream-debug-overlay__pane-sub"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  class: "stream-debug-overlay__row-meta"
};
const _hoisted_10 = {
  class: "stream-debug-overlay__seq"
};
const _hoisted_11 = {
  class: "stream-debug-overlay__ts"
};
const _hoisted_12 = {
  class: "stream-debug-overlay__size"
};
const _hoisted_13 = {
  key: 0,
  class: "stream-debug-overlay__tag"
};
const _hoisted_14 = {
  class: "stream-debug-overlay__raw-text"
};
const _hoisted_15 = {
  key: 0,
  class: "stream-debug-overlay__empty"
};
const _hoisted_16 = {
  class: "stream-debug-overlay__pane"
};
const _hoisted_17 = {
  class: "stream-debug-overlay__pane-head"
};
const _hoisted_18 = {
  class: "stream-debug-overlay__pane-sub"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
  class: "stream-debug-overlay__row-meta"
};
const _hoisted_21 = {
  class: "stream-debug-overlay__seq"
};
const _hoisted_22 = {
  class: "stream-debug-overlay__ts"
};
const _hoisted_23 = {
  class: "stream-debug-overlay__tag stream-debug-overlay__tag--event"
};
const _hoisted_24 = {
  key: 0,
  class: "stream-debug-overlay__tag"
};
const _hoisted_25 = {
  class: "stream-debug-overlay__raw-text"
};
const _hoisted_26 = {
  key: 0,
  class: "stream-debug-overlay__empty"
};
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { streamDebugBus } from './bus';
const TIME_PAD_DEFAULT = 2;
const MS_PAD_WIDTH = 3;
const JSON_INDENT = 2;
const DEFAULT_RIGHT = 16;
const DEFAULT_BOTTOM = 16;
const DRAG_MIN_VISIBLE_WIDTH = 200;
const DRAG_MIN_VISIBLE_HEIGHT = 60;
const QUERY_LIMIT = 1000;
const SEARCH_DEBOUNCE_MS = 200;
/** 判定「已贴底」的像素容差，避免亚像素/滚动条导致误判离开底部 */
const SCROLL_BOTTOM_TOLERANCE = 24;
// 复制按钮拉取「当前搜索过滤后的全量」时使用的窗口上限——比常规渲染窗口大几个量级，
// 配合 worker 内部按 keyword 过滤后再 slice(-limit)，对调试观察足够用
const COPY_QUERY_LIMIT = 1000000;
const COPY_FEEDBACK_DURATION_MS = 1800;
export default /*@__PURE__*/Object.assign({
  name: 'TempStreamDebugOverlay'
}, {
  __name: 'StreamDebugOverlay',
  setup(__props) {
    // 这些常量都是临时调试工具的内部参数，不属于业务 design tokens 范畴，故就地命名。
    const visible = ref(false);
    const paused = ref(false);
    const rawKeyword = ref('');
    const eventKeyword = ref('');
    const rawItems = ref([]);
    const eventItems = ref([]);
    const rawTotal = ref(0);
    const eventTotal = ref(0);
    const count = ref({
      rawCount: 0,
      eventCount: 0
    });
    const scope = ref({
      tabId: '',
      sessionId: '',
      roundId: 0
    });
    const rawScrollRef = ref(null);
    const eventScrollRef = ref(null);
    const rootRef = ref(null);

    // 鼠标悬停时暂停"自动滚到底"，避免新到的数据把用户当前阅读位置打断
    const rawHovered = ref(false);
    const eventHovered = ref(false);
    // 仅当用户本来就贴着底部时才跟随新数据；上滚回看后即使离开浮窗也不强制贴底
    const rawPinnedToBottom = ref(true);
    const eventPinnedToBottom = ref(true);
    const position = ref({
      left: null,
      top: null,
      right: DEFAULT_RIGHT,
      bottom: DEFAULT_BOTTOM
    });
    const positionStyle = computed(() => {
      const s = {};
      if (typeof position.value.left === 'number') s.left = `${position.value.left}px`;
      if (typeof position.value.top === 'number') s.top = `${position.value.top}px`;
      if (typeof position.value.right === 'number') s.right = `${position.value.right}px`;
      if (typeof position.value.bottom === 'number') s.bottom = `${position.value.bottom}px`;
      return s;
    });
    const rawSummary = computed(() => {
      if (rawKeyword.value) return `匹配 ${rawTotal.value} 条 · 显示末尾 ${rawItems.value.length}`;
      return `总 ${count.value.rawCount} · 显示末尾 ${rawItems.value.length}`;
    });
    const eventSummary = computed(() => {
      if (eventKeyword.value) return `匹配 ${eventTotal.value} 条 · 显示末尾 ${eventItems.value.length}`;
      return `总 ${count.value.eventCount} · 显示末尾 ${eventItems.value.length}`;
    });
    let unsubscribe = null;
    let rawRefreshScheduled = false;
    let eventRefreshScheduled = false;
    let rawDebounceTimer = null;
    let eventDebounceTimer = null;
    let dragState = null;

    /**
     * 判断滚动容器是否贴着底部。
     * @param {HTMLElement|null} el 列表滚动容器
     * @returns {boolean} 贴底或容器不存在时为 true（默认继续跟随）
     */
    function isAtBottom(el) {
      if (!el) return true;
      return el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_BOTTOM_TOLERANCE;
    }

    /**
     * 把滚动容器贴到底部。
     * @param {HTMLElement|null} el 列表滚动容器
     * @returns {void}
     */
    function scrollPaneToBottom(el) {
      if (!el) return;
      el.scrollTop = el.scrollHeight;
    }

    /**
     * 仅在「未搜索、未悬停阅读、且用户仍贴底」时跟随到底。
     * 流结束后心跳仍会触发刷新，不能仅凭 mouseleave 或未悬停就强制贴底。
     * @param {HTMLElement|null} el 列表滚动容器
     * @param {string} keyword 当前搜索关键字
     * @param {boolean} hovered 鼠标是否在该栏内
     * @param {boolean} pinned 用户是否仍处于贴底跟随
     * @returns {void}
     */
    function maybeFollowBottom(el, keyword, hovered, pinned) {
      if (keyword || hovered || !pinned) return;
      scrollPaneToBottom(el);
    }

    /** 左侧 raw 列表滚动：上滚则取消跟随，滚回底部则恢复跟随 */
    function onRawScroll() {
      rawPinnedToBottom.value = isAtBottom(rawScrollRef.value);
    }

    /** 右侧 event 列表滚动：上滚则取消跟随，滚回底部则恢复跟随 */
    function onEventScroll() {
      eventPinnedToBottom.value = isAtBottom(eventScrollRef.value);
    }
    function syncBusSnapshot() {
      count.value = streamDebugBus.getCount();
      scope.value = streamDebugBus.getScope();
    }
    async function runRefreshRaw() {
      // 暂停状态只更新计数，不重新拉数据/不重置滚动位置
      if (paused.value) {
        syncBusSnapshot();
        return;
      }
      const result = await streamDebugBus.query('raw', rawKeyword.value, QUERY_LIMIT);
      syncBusSnapshot();
      rawItems.value = result.items;
      rawTotal.value = result.total;
      await nextTick();
      maybeFollowBottom(rawScrollRef.value, rawKeyword.value, rawHovered.value, rawPinnedToBottom.value);
    }
    async function runRefreshEvent() {
      if (paused.value) {
        syncBusSnapshot();
        return;
      }
      const result = await streamDebugBus.query('event', eventKeyword.value, QUERY_LIMIT);
      syncBusSnapshot();
      eventItems.value = result.items;
      eventTotal.value = result.total;
      await nextTick();
      maybeFollowBottom(eventScrollRef.value, eventKeyword.value, eventHovered.value, eventPinnedToBottom.value);
    }
    function scheduleRefreshRaw() {
      if (rawRefreshScheduled) return;
      rawRefreshScheduled = true;
      window.requestAnimationFrame(() => {
        rawRefreshScheduled = false;
        runRefreshRaw();
      });
    }
    function scheduleRefreshEvent() {
      if (eventRefreshScheduled) return;
      eventRefreshScheduled = true;
      window.requestAnimationFrame(() => {
        eventRefreshScheduled = false;
        runRefreshEvent();
      });
    }
    function scheduleRefreshAll() {
      scheduleRefreshRaw();
      scheduleRefreshEvent();
    }
    function onClear() {
      streamDebugBus.clear();
      rawItems.value = [];
      eventItems.value = [];
      rawTotal.value = 0;
      eventTotal.value = 0;
      rawPinnedToBottom.value = true;
      eventPinnedToBottom.value = true;
    }
    const rawCopyState = ref('idle'); // idle | busy | done | error
    const eventCopyState = ref('idle');
    let rawCopyTimer = null;
    let eventCopyTimer = null;
    function copyBtnText(s) {
      if (s === 'busy') return '复制中...';
      if (s === 'done') return '已复制 ✓';
      if (s === 'error') return '复制失败';
      return '复制';
    }
    function copyBtnClass(s) {
      if (s === 'done') return 'stream-debug-overlay__copy-btn--done';
      if (s === 'error') return 'stream-debug-overlay__copy-btn--error';
      return null;
    }
    async function writeClipboard(text) {
      try {
        var _navigator$clipboard;
        if ((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return true;
        }
      } catch {
        // 回退到 execCommand
      }
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        ta.setAttribute('readonly', '');
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
      } catch {
        return false;
      }
    }
    function settleCopyState(kind, ok) {
      const stateRef = kind === 'raw' ? rawCopyState : eventCopyState;
      stateRef.value = ok ? 'done' : 'error';
      if (kind === 'raw') {
        if (rawCopyTimer) clearTimeout(rawCopyTimer);
        rawCopyTimer = setTimeout(() => {
          rawCopyState.value = 'idle';
        }, COPY_FEEDBACK_DURATION_MS);
      } else {
        if (eventCopyTimer) clearTimeout(eventCopyTimer);
        eventCopyTimer = setTimeout(() => {
          eventCopyState.value = 'idle';
        }, COPY_FEEDBACK_DURATION_MS);
      }
    }
    async function copyKind(kind) {
      const stateRef = kind === 'raw' ? rawCopyState : eventCopyState;
      if (stateRef.value === 'busy') return;
      stateRef.value = 'busy';
      const keyword = kind === 'raw' ? rawKeyword.value : eventKeyword.value;
      const _await$streamDebugBus = await streamDebugBus.query(kind, keyword, COPY_QUERY_LIMIT),
        items = _await$streamDebugBus.items;
      if (!items.length) {
        settleCopyState(kind, false);
        return;
      }
      const text = JSON.stringify(items, null, JSON_INDENT);
      const ok = await writeClipboard(text);
      settleCopyState(kind, ok);
    }
    function onCopyRaw() {
      return copyKind('raw');
    }
    function onCopyEvent() {
      return copyKind('event');
    }
    function formatTime(ts) {
      const d = new Date(ts);
      const pad = function (n) {
        let w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIME_PAD_DEFAULT;
        return String(n).padStart(w, '0');
      };
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), MS_PAD_WIDTH)}`;
    }
    function summarizeEvent(ev) {
      if (!ev || typeof ev !== 'object') return typeof ev;
      return ev.event || ev.type || ev.phase || ev.finish || ev.info && (ev.info.event || ev.info.type) || 'object';
    }
    function stringifyEvent(ev) {
      try {
        return JSON.stringify(ev, null, JSON_INDENT);
      } catch {
        return String(ev);
      }
    }
    function onDragStart(e) {
      var _rootRef$value;
      if (e.button !== 0) return;
      const rect = (_rootRef$value = rootRef.value) === null || _rootRef$value === void 0 ? void 0 : _rootRef$value.getBoundingClientRect();
      if (!rect) return;
      dragState = {
        startX: e.clientX,
        startY: e.clientY,
        originLeft: rect.left,
        originTop: rect.top
      };
      position.value = {
        left: rect.left,
        top: rect.top,
        right: null,
        bottom: null
      };
      window.addEventListener('pointermove', onDragMove);
      window.addEventListener('pointerup', onDragEnd);
    }
    function onDragMove(e) {
      if (!dragState) return;
      const dx = e.clientX - dragState.startX;
      const dy = e.clientY - dragState.startY;
      const left = Math.max(0, Math.min(window.innerWidth - DRAG_MIN_VISIBLE_WIDTH, dragState.originLeft + dx));
      const top = Math.max(0, Math.min(window.innerHeight - DRAG_MIN_VISIBLE_HEIGHT, dragState.originTop + dy));
      position.value = {
        left,
        top,
        right: null,
        bottom: null
      };
    }
    function onDragEnd() {
      dragState = null;
      window.removeEventListener('pointermove', onDragMove);
      window.removeEventListener('pointerup', onDragEnd);
    }
    function onKeyDown(e) {
      // Ctrl/⌘ + Shift + S：切换显示。Win 认 ctrlKey，Mac 认 metaKey（Command）。
      // preventDefault 阻止 Chrome「保存网页 / 另存为」默认行为。
      const modifierPressed = e.ctrlKey || e.metaKey;
      if (modifierPressed && e.shiftKey && (e.key === 'S' || e.key === 's')) {
        e.preventDefault();
        visible.value = !visible.value;
      }
    }
    watch(visible, v => {
      streamDebugBus.setEnabled(v);
      if (v) scheduleRefreshAll();
    });

    // 左右搜索独立：raw 关键字变化只刷新左侧、event 关键字变化只刷新右侧，互不干扰
    watch(rawKeyword, () => {
      if (rawDebounceTimer) clearTimeout(rawDebounceTimer);
      rawDebounceTimer = setTimeout(scheduleRefreshRaw, SEARCH_DEBOUNCE_MS);
    });
    watch(eventKeyword, () => {
      if (eventDebounceTimer) clearTimeout(eventDebounceTimer);
      eventDebounceTimer = setTimeout(scheduleRefreshEvent, SEARCH_DEBOUNCE_MS);
    });
    onMounted(() => {
      syncBusSnapshot();
      unsubscribe = streamDebugBus.subscribe(scheduleRefreshAll);
      window.addEventListener('keydown', onKeyDown, true);
    });
    onBeforeUnmount(() => {
      if (unsubscribe) unsubscribe();
      if (rawDebounceTimer) clearTimeout(rawDebounceTimer);
      if (eventDebounceTimer) clearTimeout(eventDebounceTimer);
      if (rawCopyTimer) clearTimeout(rawCopyTimer);
      if (eventCopyTimer) clearTimeout(eventCopyTimer);
      window.removeEventListener('keydown', onKeyDown, true);
      window.removeEventListener('pointermove', onDragMove);
      window.removeEventListener('pointerup', onDragEnd);
      streamDebugBus.setEnabled(false);
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        class: "stream-debug-overlay",
        style: _normalizeStyle(positionStyle.value),
        onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
      }, [_createElementVNode("div", {
        class: "stream-debug-overlay__head",
        onPointerdown: onDragStart
      }, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "stream-debug-overlay__title"
      }, "SSE Debug · 临时调试浮窗", -1)), _createElementVNode("span", _hoisted_1, [_cache[16] || (_cache[16] = _createTextVNode(" session: ", -1)), _createElementVNode("b", {
        title: scope.value.sessionId
      }, _toDisplayString(scope.value.sessionId || 'pending'), 9, _hoisted_2), _cache[17] || (_cache[17] = _createTextVNode("  |  raw: ", -1)), _createElementVNode("b", null, _toDisplayString(count.value.rawCount), 1), _cache[18] || (_cache[18] = _createTextVNode("  |  events: ", -1)), _createElementVNode("b", null, _toDisplayString(count.value.eventCount), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: _normalizeClass(["stream-debug-overlay__btn", {
          'stream-debug-overlay__btn--active': paused.value
        }]),
        onClick: _cache[0] || (_cache[0] = $event => paused.value = !paused.value),
        onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, _toDisplayString(paused.value ? '继续' : '暂停'), 35), _createElementVNode("button", {
        class: "stream-debug-overlay__btn",
        onClick: onClear,
        onPointerdown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, "清空", 32), _createElementVNode("button", {
        class: "stream-debug-overlay__btn",
        onClick: _cache[3] || (_cache[3] = $event => visible.value = false),
        onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, "关闭", 32)])], 32), _cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "stream-debug-overlay__tip"
      }, " Ctrl/⌘ + Shift + S 切换显示 · 仅当前页签 / 当前 session · Worker + IndexedDB 持久化 · 复制按钮可一键拷贝当前过滤后的全量 JSON ", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_createElementVNode("header", _hoisted_6, [_cache[20] || (_cache[20] = _createElementVNode("span", {
        class: "stream-debug-overlay__pane-title"
      }, "Raw Chunks", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => rawKeyword.value = $event),
        class: "stream-debug-overlay__search",
        type: "search",
        placeholder: "搜索原始 chunk（支持子串）",
        onPointerdown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
      }, null, 544), [[_vModelText, rawKeyword.value]]), _createElementVNode("span", _hoisted_7, _toDisplayString(rawSummary.value), 1), _createElementVNode("button", {
        class: _normalizeClass(["stream-debug-overlay__copy-btn", copyBtnClass(rawCopyState.value)]),
        disabled: rawCopyState.value === 'busy',
        onClick: onCopyRaw,
        onPointerdown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
      }, _toDisplayString(copyBtnText(rawCopyState.value)), 43, _hoisted_8)]), _createElementVNode("div", {
        ref_key: "rawScrollRef",
        ref: rawScrollRef,
        class: "stream-debug-overlay__pane-body",
        onScroll: onRawScroll,
        onMouseenter: _cache[8] || (_cache[8] = $event => rawHovered.value = true),
        onMouseleave: _cache[9] || (_cache[9] = $event => rawHovered.value = false)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rawItems.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: `raw-${item.id}`,
          class: "stream-debug-overlay__row stream-debug-overlay__row--raw"
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, "#" + _toDisplayString(item.id), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(formatTime(item.ts)), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(item.size) + "B", 1), item.source ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.source), 1)) : _createCommentVNode("", true)]), _createElementVNode("pre", _hoisted_14, _toDisplayString(item.text), 1)]);
      }), 128)), !rawItems.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(rawKeyword.value ? '无匹配数据' : '暂无数据，发起一次研究模式对话试试'), 1)) : _createCommentVNode("", true)], 544)]), _createElementVNode("section", _hoisted_16, [_createElementVNode("header", _hoisted_17, [_cache[21] || (_cache[21] = _createElementVNode("span", {
        class: "stream-debug-overlay__pane-title"
      }, "Parsed Events", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => eventKeyword.value = $event),
        class: "stream-debug-overlay__search",
        type: "search",
        placeholder: "搜索解析事件（在 JSON 内查找）",
        onPointerdown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
      }, null, 544), [[_vModelText, eventKeyword.value]]), _createElementVNode("span", _hoisted_18, _toDisplayString(eventSummary.value), 1), _createElementVNode("button", {
        class: _normalizeClass(["stream-debug-overlay__copy-btn", copyBtnClass(eventCopyState.value)]),
        disabled: eventCopyState.value === 'busy',
        onClick: onCopyEvent,
        onPointerdown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
      }, _toDisplayString(copyBtnText(eventCopyState.value)), 43, _hoisted_19)]), _createElementVNode("div", {
        ref_key: "eventScrollRef",
        ref: eventScrollRef,
        class: "stream-debug-overlay__pane-body",
        onScroll: onEventScroll,
        onMouseenter: _cache[13] || (_cache[13] = $event => eventHovered.value = true),
        onMouseleave: _cache[14] || (_cache[14] = $event => eventHovered.value = false)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventItems.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: `ev-${item.id}`,
          class: "stream-debug-overlay__row stream-debug-overlay__row--event"
        }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, "#" + _toDisplayString(item.id), 1), _createElementVNode("span", _hoisted_22, _toDisplayString(formatTime(item.ts)), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(summarizeEvent(item.event)), 1), item.source ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.source), 1)) : _createCommentVNode("", true)]), _createElementVNode("pre", _hoisted_25, _toDisplayString(stringifyEvent(item.event)), 1)]);
      }), 128)), !eventItems.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(eventKeyword.value ? '无匹配数据' : '暂无解析事件'), 1)) : _createCommentVNode("", true)], 544)])])], 4)), [[_vShow, visible.value]]);
    };
  }
});